import {
  useEffect,
  useState} from "react";
import { ThemeProvider } from "@mui/material/styles";
import { MuiTheme } from "../styles/MuiDataTableStyle";
import { PlanTable } from "../components/PlanTable";
import { getPlans } from "../services/plansService";
import { useStateAuthValue } from "../context/AuthState";
import { useToast } from "../context/Toast/ToastProvider";
import { showToast, ToastType } from "../utils/ToastUtil";
import { LoadingModal } from "../components/Modals/LoadingModal";
import PageHeader from "../components/PageHeader";

const Users = () => {
  const [{userToken}] = useStateAuthValue();
  const [data, setData] = useState([]);
  const [dataLength, setDataLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const toastDispatch = useToast();
  const displayError = (msg) => showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  
  const getPlansData = async (params) => {
    const response = await getPlans(userToken, displayError, params);
    setData(response?.plans);
    setDataLength(response?.plans?.length)
    setCurrentPage(response?.currentPage);
    setTotalPages(response?.totalPages > 1 && response?.currentPage === 0 ? -1 : response?.totalPages);
  }
  useEffect(() => {
    setLoading(true);
    getPlansData()
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userToken]);

  return (
    <ThemeProvider theme={MuiTheme}>
      <div className="users">
        <div className="users-table-container">
          <PageHeader title="Listado de planes de empresa" />
          <PlanTable 
          data={data} 
          getPlansData={getPlansData}
          setLoading={setLoading}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          dataLength={dataLength}
          currentPage={currentPage}
          />
        </div>
      </div>
      {loading && <LoadingModal />}
    </ThemeProvider>
  );
};

export default Users;
